// Oggetto dinamico pre-compilato per invio PEC/Email di una pratica.
// Formato: "Sinistro del [data sinistro] n°[n° sinistro compagnia gestionaria] - [Nome Cognome cliente] c/ [Cognome Nome controparte]"
import { formatDate } from "./format";
import { isAzienda } from "./nominativo";

// Nome cliente principale nel formato "Nome Cognome".
const clienteNome = (p) => {
  const a = (p.assistiti && p.assistiti[0]) || {};
  if (isAzienda(a)) return (a.ragione_sociale || a.denominazione || "").trim();
  const nc = [a.nome, a.cognome].filter(Boolean).join(" ").trim();
  if (nc) return nc;
  return (p.nome_assistito || a.ragione_sociale || a.denominazione || "").trim();
};

// Nome controparte principale nel formato "Cognome Nome".
const controparteNome = (p) => {
  const c = (p.controparti && p.controparti[0]) || {};
  if (isAzienda(c)) return (c.ragione_sociale || c.denominazione || "").trim();
  const cn = [c.cognome, c.nome].filter(Boolean).join(" ").trim();
  if (cn) return cn;
  return (c.ragione_sociale || c.denominazione || p.controparte_ragione_sociale || "").trim();
};

// N° sinistro della compagnia gestionaria (cliente se RD, altrimenti controparte).
const numSinistroGestionaria = (p) => {
  const isRD = String(p.tipo || p.tipo_sinistro || "").trim().toUpperCase() === "RD";
  const cp0 = (p.controparti && p.controparti[0]) || {};
  const v = isRD ? (p.assistito_num_sinistro || "") : (cp0.num_sinistro || p.controparte_num_sinistro || "");
  return String(v || "").trim();
};

export function buildPraticaOggetto(p) {
  if (!p) return "";
  const ds = p.data_sinistro ? formatDate(p.data_sinistro) : "";
  const nsin = numSinistroGestionaria(p);
  const cliente = clienteNome(p);
  const cp = controparteNome(p);
  return `Sinistro del ${ds} n°${nsin} - ${cliente} c/ ${cp}`;
}
